export const skillsHero = {
  title: '習得スキル一覧',
  titleEn: 'SKILLS',
  lead: '執事に求められる技能を、5つの領域に整理して体系的に習得します。基礎から管理能力まで、段階的な積み上げで確かな力を育みます。',
};

export const skillsIntro = {
  title: '5つのスキル領域',
  titleEn: 'Five Skill Domains',
  description: '執事に求められる技能を、五つの領域に整理しています。サービスの技術、先を読む観察力、品格ある対話、家政を束ねる管理力、そして動じない危機対応力——どの領域も、実践を重ねることで初めて身につくものです。',
};

export const skillAreas = [
  {
    id: 'service',
    number: '01',
    title: 'サービス技能',
    titleEn: 'Service Skills',
    subtitle: 'テーブル／ティー／ワイン／衣類ケア',
    description: '邸宅サービスの中核をなす実務技能です。テーブルセッティング、ティーサービス、ワインの知識と提供、衣類やリネンの管理まで、執事の日常業務に直結する技能を体系的に習得します。',
    skills: [
      'フォーマルテーブルの設営と撤収',
      '紅茶・中国茶の種類別抽出と提供',
      'ワインの基礎知識・テイスティング・マリアージュ',
      '衣類・リネンの素材別ケアと収納管理',
      'カトラリー・グラス類の識別と取扱い',
    ],
    startCourse: 'エッセンシャル',
    deepenCourse: 'アドバンス／マスター',
    icon: 'ri-goblet-line',
    imageSeq: 'skill-service',
  },
  {
    id: 'observation',
    number: '02',
    title: '観察力・先回り',
    titleEn: 'Observation & Anticipation',
    subtitle: '状況把握／先読み／気配り',
    description: '雇主やゲストのわずかな仕草や表情から意図を読み取り、求められる前に行動する感覚を養います。これはマニュアルでは伝えきれない、経験と訓練で磨かれる中核的な能力です。',
    skills: [
      'ゲストの仕草・表情からの意図察知',
      '場の空気を読んだタイミング判断',
      '言葉にされない要望の先回り対応',
      '季節や時間帯に応じた環境調整',
    ],
    startCourse: 'エッセンシャル',
    deepenCourse: 'アドバンス／マスター',
    icon: 'ri-eye-line',
    imageSeq: 'skill-observation',
  },
  {
    id: 'communication',
    number: '03',
    title: 'コミュニケーション',
    titleEn: 'Communication',
    subtitle: '言葉遣い／距離感／守秘／品格',
    description: '執事の言葉と立ち居振る舞いは、邸宅全体の印象を左右します。敬語の正確さだけでなく、相手との適切な距離感、守秘義務の徹底、書面や電話での応対まで、総合的な対話力を鍛えます。',
    skills: [
      '状況別の敬語・謙譲語の使い分け',
      'ゲストとの適切な距離感の維持',
      '守秘義務の徹底と情報管理',
      '書面・メール・電話での格式ある応対',
      '多言語での基本接遇（英語・中国語）',
    ],
    startCourse: 'エッセンシャル',
    deepenCourse: 'アドバンス／マスター',
    icon: 'ri-chat-1-line',
    imageSeq: 'skill-communication',
  },
  {
    id: 'management',
    number: '04',
    title: '管理能力',
    titleEn: 'Management',
    subtitle: '家政管理／スケジュール／スタッフ統率',
    description: '執事は一邸宅の運営責任者です。日々の家政管理、年間行事のスケジュール策定、外部業者との折衝、複数スタッフの統率まで、マネジメント能力が求められます。',
    skills: [
      '年間行事・日常業務のスケジュール管理',
      '家計・支出の予算管理と報告',
      '外部業者（造園・設備・ケータリング）の統括',
      '複数スタッフのシフト管理と指揮',
      '美術品・ワインセラー等の資産管理',
    ],
    startCourse: 'アドバンス',
    deepenCourse: 'マスター',
    icon: 'ri-pie-chart-line',
    imageSeq: 'skill-management',
  },
  {
    id: 'crisis',
    number: '05',
    title: '危機対応力',
    titleEn: 'Crisis Response',
    subtitle: '緊急時対応／冷静判断／安全確保',
    description: '邸宅で起こりうるあらゆる緊急事態に、冷静かつ的確に対処する力を養います。医療緊急時、火災や地震などの災害、不審者対応まで、執事には高度な危機管理能力が求められます。',
    skills: [
      '救急・医療緊急時の初動対応',
      '火災・地震など災害時の避難誘導',
      '不審者・セキュリティ事案への対処',
      'トラブル発生時の雇主・ゲストの心情配慮',
      '関係機関（警察・消防・医療）との連携手順',
    ],
    startCourse: 'マスター',
    deepenCourse: 'マスター',
    icon: 'ri-shield-line',
    imageSeq: 'skill-crisis',
  },
];

export const courseSkillsTable = {
  title: 'コース別に身につくスキル',
  titleEn: 'Skills by Course',
  description: 'どの領域をどこまで身につけるかは、コースによって異なります。基礎から管理・危機対応まで、段階的に到達目標を引き上げていきます。各コースで学ぶ主なスキルは以下のとおりです。',
  courses: [
    {
      name: 'エッセンシャル',
      nameEn: 'Essential',
      scope: '基礎の所作とサービス基礎',
      details: 'テーブルセッティング、ティーサービス、基本敬語、観察の基礎。執事としての第一歩となる所作とサービス基礎を網羅。',
      href: '/courses/essential',
      icon: 'ri-seedling-line',
    },
    {
      name: 'アドバンス',
      nameEn: 'Advanced',
      scope: '高度サービス・ワイン・イベント・国際マナー',
      details: 'ワインサービス、フォーマル晩餐会運営、国際マナー、スタッフ管理基礎。専門性を高め、実務に対応できる力を養う。',
      href: '/courses/advanced',
      icon: 'ri-stack-line',
    },
    {
      name: 'マスター',
      nameEn: 'Master',
      scope: '管理・危機対応・VIP対応・リーダーシップ',
      details: '全領域の統合、危機管理、VIP専任サービス、スタッフ統率。執事としての最高水準を目指す。',
      href: '/courses/master',
      icon: 'ri-star-line',
    },
  ],
};

export const achievementGoals = {
  title: '到達目標',
  titleEn: 'Achievement Targets',
  description: '5つのスキル領域について、コース別の到達目標を以下に示します。これらは「修了時点で目指す水準」であり、修了を保証する実績値ではありません。',
  domains: [
    { name: 'サービス技能', key: 'service' },
    { name: '観察力・先回り', key: 'observation' },
    { name: 'コミュニケーション', key: 'communication' },
    { name: '管理能力', key: 'management' },
    { name: '危機対応力', key: 'crisis' },
  ],
  courses: [
    {
      name: 'エッセンシャル',
      nameEn: 'Essential',
      color: 'bg-accent-500',
      values: { service: 40, observation: 30, communication: 35, management: 10, crisis: 5 },
    },
    {
      name: 'アドバンス',
      nameEn: 'Advanced',
      color: 'bg-accent-600',
      values: { service: 70, observation: 60, communication: 65, management: 50, crisis: 30 },
    },
    {
      name: 'マスター',
      nameEn: 'Master',
      color: 'bg-accent-700',
      values: { service: 95, observation: 90, communication: 90, management: 90, crisis: 90 },
    },
  ],
};

export const certificationSection = {
  title: 'スキルを証明する',
  titleEn: 'Certifying Your Skills',
  description: '身につけたスキルは、修了実技試験の合格を通じて協会認定資格として証明されます。合格者には修了証を授与し、執事としての専門性を対外的に示すことができます。',
  note: '※本資格は本科コース（エッセンシャル／アドバンス／マスター）の修了者を対象とし、法人研修の受講証とは異なります。',
};

export const skillsFaqs = [
  {
    question: 'どんなスキルを学べますか？',
    answer: 'サービス技能、観察力・先回り、コミュニケーション、管理能力、危機対応力の5領域を体系的に学びます。',
  },
  {
    question: 'スキルの習得を証明できますか？',
    answer: 'はい。各コース修了時の実技試験に合格すると、協会認定資格を取得できます。',
  },
  {
    question: '未経験でも身につきますか？',
    answer: 'はい。基礎から段階的に積み上げる設計のため、未経験の方も無理なく習得できます。',
  },
];

export const skillsRelatedPages = [
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: '実践トレーニング',
    description: '実技とロールプレイング中心の訓練',
    href: '/training',
  },
  {
    title: '使用教材',
    description: '協会監修の教科書全15冊',
    href: '/materials',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
];